import { clearFilter } from './clear-filter';
export const setFilterValue = (props) => {
    const { filter, key, value, selected, multiselect } = props;
    if (!(key in filter.sections)) {
        throw new Error(`Invalid filter key '${key}' for ${filter.type} filter.`);
    }
    // If single-select, unselect old option(s)
    if (!multiselect) {
        clearFilter(filter, [key]);
    }
    // Update new option
    const filterOption = filter.sections[key].options.find(option => option.value === value);
    if (filterOption)
        filterOption.selected = selected;
};
